module.exports = __webpack_public_path__ + "img/fl1.2b6f0a1a.jpg";